import { AuthGuardService } from '../../../../src/app/shared/services/auth.guard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { LayoutComponent } from '../app/modules/layout/layout.component';
import { LoginComponent } from '../app/modules/login/login.component';
import { TwoFactorAuthenticationComponent } from '../app/modules/two-factor-authentication/two-factor-authentication.component';
import { AutoLoginComponent } from '../app/modules/auto-login/auto-login.component';
import { HomePanelComponent } from '../app/modules/home-panel/home-panel.component';
import { CarDetailsComponent } from '../app/modules/car-details/car-details.component';
import { GarageVisitsComponent } from '../app/modules/garage-visits/garage-visits.component';
import { DepositesComponent } from '../app/modules/deposites/deposites.component';
import { TyreOrdersComponent } from '../app/modules/tyre-orders/tyre-orders.component';
import { DepositeVisitComponent } from '../app/modules/deposite-visit/deposite-visit.component';
import { TyreOrderVisitComponent } from '../app/modules/tyre-order-visit/tyre-order-visit.component';
import { RelocationOrdersComponent } from '../app/modules/relocation-orders/relocation-orders.component';
import { RelocationOrderComponent } from '../app/modules/relocation-order/relocation-order.component';
import { DefaultGarageComponent } from '../app/modules/default-garage/default-garage.component';

import { P404Component } from '../../../../src/app/shared/pages/error/404.component';
import { P500Component } from '../../../../src/app/shared/pages/error/500.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },

  {
    path: '',
    component: LayoutComponent,
    data: {
      title: 'Point-S'
    },
    children: [

      {
        path: 'auto-login/:nr/:vin',
        component: AutoLoginComponent
      },

      {
        path: 'auto-login-md5/:nrMd5/:vinMd5',
        component: AutoLoginComponent
      },

      {
        path: 'auto-login-md5',
        component: AutoLoginComponent
      },

      {
        path: 'login',
        component: LoginComponent
      },

      {
        path: 'tfa',
        component: TwoFactorAuthenticationComponent
      },

      {
        path: 'home',
        component: HomePanelComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'car',
        component: CarDetailsComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'visits',
        component: GarageVisitsComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'deposites',
        component: DepositesComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'tyre-orders',
        component: TyreOrdersComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'deposite-visit/:id',
        component: DepositeVisitComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'tyre-order-visit/:id',
        component: TyreOrderVisitComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'relocation-orders',
        component: RelocationOrdersComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'relocation-order/:id',
        component: RelocationOrderComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'default-garage',
        component: DefaultGarageComponent,
        canActivate: [AuthGuardService]
      }
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
